import React          from 'react';
import { Meteor }	  from 'meteor/meteor';
import connectField   from 'uniforms/connectField';
import moment from 'moment';

import {
  Col,
  FormControl,
  FormGroup,
  ControlLabel
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

class DatePickerField extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			date: this.props.value
		};
	}

	render() {
		return (
			<div>
				<label className="control-label">
					{this.props.label}&nbsp;
				</label>
				<DatePicker
        dayLabels={['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']}
        monthLabels={['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']}
        id={this.props.id} value={this.state.date} onChange={(value) => { this.setState({ date: moment(value).format() }); this.props.onChange(moment(value).format()); }}/> <br/>
			</div>
		);
	}
}

export default connectField(DatePickerField);



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/datePickerField.js
 **/